export const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export const fullMonths = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const monthsObj = months.reduce((previous, current, index) => {
  return {
    ...previous,
    [index + 1]: {
      short: current,
      full: fullMonths[index]
    }
  };
}, <Record<string, Record<"short" | "full", string>>>{});


